import React, { useState, useEffect, useRef } from "react";
import {
  Grid,
  Box,
  TextField,
  Typography,
  Backdrop,
  CircularProgress,
  IconButton,
  Button,
  InputAdornment,
  TablePagination,
} from "@material-ui/core";
import AttachmentsCover from "../../../components/Attachments/AttachmentsCover";
import WarningBox from "../Components/WarningBox";
import { Download, Error } from "@material-ui/icons";
import ConfirmationModal from "../../../components/ConfirmModal/ConfirmationModal";
import TaxTeamTable from "../NewInvoice/Tables/taxteamtable";

// import DocViewer,  { PDFRenderer, PNGRenderer  ,DocViewerRenderers } from "react-doc-viewer";
// import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer";

// import FormControlLabel from "@mui/material/FormControlLabel";
import Card from "../../../StyledComponents/Card/Card";
import CardHeader from "../../../StyledComponents/Card/CardHeader";
import CardText from "../../../StyledComponents/Card/CardText";
import CardBody from "../../../StyledComponents/Card/CardBody";
import { makeStyles } from "@material-ui/styles";
import { Checkbox } from "@material-ui/core";
import VendorTaxTable from "../NewInvoice/Tables/Vendor_Tax_Detail";
import Heading from "../../../StyledComponents/Heading/Heading";
import PODetail from "../NewInvoice/Tables/PoDetail_Table";

import {
  clearState,
  getCommentsByInvoiceId,
  getInvoiceByInvoiceIdAndRoleId,
  getAllInvoiceDetailByInvoiceId,
  getRefrenceDataList,
  getVendorByPO,
  updateInvoiceByTaxTeam,
  uploadAdditioalDocumentFile,
  uploadFile,
  vendorTaxDetailForCnic,
  changeInvoiceStatus,
  deleteAttachment,
  getMethodForPageRefresh,
} from "../actions";

import InvoiceGuideLine from "../NewInvoice/InvoiceGuidLines/InvoiceGuideLine.js";
import CustomSnackbar from "../../../CustomSnackbar";
import InvoiceCheckboxes from "../Components/InvoiceDetails/InvoiceCheckboxes";
import InvoiceRadioButtons from "../Components/InvoiceDetails/InvoiceRadiobuttons";
import InvoiceTextField from "../Components/InvoiceDetails/InvoiceTextFields";
import TaxDetail from "../Components/TaxDetails/TaxDetails";
import TaxTable from "../NewInvoice/Tables/Tax_Table";
import ProceedBtn from "../NewInvoice/InvoiceGuidLines/proceedbtn";
import { dashboardStyle } from "../Components/InvoiceDetails/style";
import { useNavigate, useLocation } from "react-router-dom";
import { ArrowBack, Delete } from "@material-ui/icons";
import VisibilityRoundedIcon from "@material-ui/icons/VisibilityRounded";
import downloadAttachments from "../../../Functions/downloadAttachments";
import CommentHistory from "../NewInvoice/Tables/CommentHistory";
import POAlertDialog from "../NewInvoice/Tables/PoTableAlert";
import TaxTableV2 from "../NewInvoice/Tables/TaxTableV2.jsx";
import PageNotFound from "../NewInvoice/PageNotFound.js";
function getParameterByName(name, url) {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)");
  var results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return "";
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}

const useStyles = makeStyles(dashboardStyle);

const TaxTeamPage = () => {
  const classes = useStyles();
  const [multipleData, setMultipleData] = useState({
    invoice_Type: [],
  });
  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    setTimeout(() => {
      if (location?.state?.msg) {
        setSuccessMessage(location?.state?.msg);
        // navigate(location.pathname, { replace: true })
        navigate(
          {
            pathname: location.pathname,
            search: location.search,
          },
          { replace: true }
        );
      }
    }, 2000);
  }, []);
  const invoiceId = getParameterByName("invoiceId");
  const roleId = getParameterByName("roleId");
  const roleName = getParameterByName("roleName");
  const vendorCode = getParameterByName("vendorCode");
  const edit = getParameterByName("edit");
  const status = getParameterByName("status");

  const invoicePayload = {
    Invoice_id: invoiceId,
    Vendor_Code: vendorCode,
  };

  const role = {
    roleId: roleId,
    roleName: roleName,
  };
  const [selectedRole, setSelectedRole] = useState(
    role ? { role: role?.roleName } : ""
  );

  const [poBasedState, setPoBasedState] = useState("PO");
  // const [physicalOrEInvoice, setPhysicalOrEInvoice] = useState("Physical");
  const [attachInvoiceLoading, setAttachInvoiceLoading] = useState(false);
  const [attachmentFile_UI, setAttchmentFile_UI] = useState([]);

  const [openInvoiceGuideLine, setOpenInvoiceGuideLine] = useState(false);
  // const [isLoading, setIsLoading] = useState(true);

  const [openWarningBox, setOpenWarningBox] = useState(false);
  const [currentStateForDeleteion, setCurrentStateForDeleteion] = useState("");

  const [commentsList, setCommentsList] = useState([]);
  const [commentsLoading, setCommentsLoading] = useState(false);
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [statusForPayload, setStatusForPayload] = useState("");
  const [confirmationMessage, setConfirmationMessage] = useState("");
  const [attachError, setAttachError] = useState("");
  const [alertMessage, setAlertMessage] = useState(false);
  const [taxErrorMsg, setTaxErrorMsg] = useState("");

  const invoice_attachmentRef = useRef(null);
  const additionalAttachmentRef = useRef(null);
  const errorMessageRef = useRef(null);
  const [allowToProceed, setAllowToProceed] = useState(true);
  const [pageLoader, setPageLoader] = useState(false);
  useEffect(() => {
    if (invoicePayload.Invoice_id) {
      getMethodForPageRefresh(
        invoicePayload.Invoice_id,
        status,
        setAllowToProceed,
        setPageLoader
      );
    }
  }, [invoicePayload.Invoice_id, status]);
  const [formState, setFormState] = useState({
    isInitiator: false,
    isDeptCordinator: false,
    isHR: false,
    isPCDV: false, // EFDV initiator
    isVPPayment: false,
    isVFPayment: false,
    isSubmittedByVendor: false,
    isImport: false,
    isLogistics: false,

    pO_Based: true,
    isPSID: false,
    psid: "",
    urgent: false,
    skipTaxStep: false,
    isReturn: false,
    invoice_Id: "",
    grn_No: "",
    pO_No: "",
    po_Date : "",
    due_Date : "",
    plant_Code : "",
    barcode_No: "",
    demandType: "",
    invoice_Type: "",
    invoice_No: "",
    invoiceCategory: "",

    invoice_Desc: "",
    invoice_Amount: "",
    final_Invoice_Amount: "",
    dept_coordinator: "",
    irUser: "",
    ipUser: "",
    taxTeam: "",
    vendor_Code: "",
    vendor_Name: "",
    invoice_Date: "",
    lineManager: "",
    directorHR: "",
    sharedServices: "",
    invoice_attachment: "",
    additionalDocIds: "", // paths
    comments: "",
    additionalDocIds_array: [], // additional documents in array
    invoice_Accounts_list: [
      {
        glAccount: "",
        costCenter: "",
        costCenterOwner: "",
        costCenterOwnerName: "",
        horizonId: "",
        vendorCode: "",
        amount: 0,
        profitCenter: "",
        department: "",
      },
    ],

    invoicePORef_List: [
      {
        poItem: "", //  item #
        poNumber: "", // poNumber
        refDoc: "", // GRN No
        quantity: "", // GRN quantity
        val_Loccur: "", // GRN amount
        invoicE_QTY: "", //  consumed quantity
        invoicE_VAL: 0, // consumed Amount
        inpuT_QTY: "", //  invoice QTY
        inpuT_VAL: "", //  Invoice amount
        currency: "", // currency
      },
    ],

    Expense_Accounts_list: [
      // Invoice_Accounts_list for back-end
      {
        expenseDate: "",
        description: "",
        amount: 0,
        glAccount: "",
        costCenter: "",
        fixedAsset: "",
        tType: "",
        profitCenter: "",
        costCenterOwner: "",
        costCenterOwnerName: "",
        horizonId: "",
        vendorCode: "",
        department: "",
      },
    ],
    Invoice_Clearingvendor_list: [
      {
        vendorCode: "",
        VendorName: "",
        amount: "",
      },
    ],
    PageNo: 1,
    RowsOfPage: 25,
    verified: false,
  });

  const [taxFormState, setTaxFormState] = useState({
    invoice_Id: invoicePayload?.Invoice_id || "",
    cnic: "",
    ntn: "",
    salesTaxCode: "",
    salesTaxAmount: "",
    isPCDV: false,
    calculateTax: false,
    xmlTaxDetail: "",
    comments: "",
    actionPerform: "",
    commentBy: "",
    status: "",
    additionalDocIds: [],
    invoice_No: "",
    vendor_tax_detail: [],
    isReturn: false,

    taxCard_List: [
      // invoice_TaxDetails earlier
      {
        invoice_Id: invoicePayload?.Invoice_id || 0,
        category: "",
        purchaseType: "",
        supplierJurisdiction: "",
        supplierType: "",
        status: "",
        fillingStatus: "",
        goodsNature: "",
        taxType: "",
        taxCode: "",
        amount: 0,
      },
    ],
    taxCard_ListCheck: [],
  });

  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const taxChangeHandler = (e) => {
    const { name, value } = e.target;
    setTaxFormState((taxFormState) => ({
      ...taxFormState,
      [name]: value,
    }));
  };
  const changeHandler = (e) => {
    const { name, value } = e.target;
    setFormState((formState) => ({
      ...formState,
      [name]: value,
    }));

    if (name === "pO_No") {
      getVendorByPO(value, "vendor_Code", setFormState);
      // if passing PONumber
      // getPODetails(value, "",setFormState)
      // form dummy data
      // getPODetails(setFormState)
    }
  };
  const [deleteLoader, setdeleteLoader] = useState(false);
  const deleteAttachmentFunc = () => {
    let ss = currentStateForDeleteion?.ss;
    let f = currentStateForDeleteion?.f;
    deleteAttachment(
      setTaxFormState,
      setAttachmentURLList,
      setOpenWarningBox,
      taxFormState,
      attachmentURLList,
      currentStateForDeleteion?.f,
      setdeleteLoader
    );
    // const files = taxFormState.additionalDocIds.filter((x, i) => {
    //   const n = x.split("\\");
    //   const nn = n[n.length - 1];
    //   return nn !== ss;
    // });
    // setTaxFormState((taxFormState) => ({
    //   ...taxFormState,
    //   additionalDocIds: files,
    // }));

    // //removing data from attachemt list for preview
    // let filtered_attachs = attachmentURLList?.filter((x) => x !== f);
    // setAttachmentURLList(filtered_attachs);
    // setAttachmentURL(filtered_attachs[filtered_attachs.length - 1]);
  };

  const showVendorAndPO_NumberForImport = () => {
    let show = selectedRole?.role === "Import" ? true : false;
    if (selectedRole?.role === "Import" && formState.demandType === "Deposit") {
      show = false;
    }
    return show;
  };

  const showVendorCodeForImport = () => {
    let show = selectedRole?.role === "Import" ? true : false;
    if (
      selectedRole?.role === "Import" &&
      formState.demandType === "Spare Parts"
    ) {
      show = false;
    }
    if (
      selectedRole?.role === "Import" &&
      formState.demandType === "Material"
    ) {
      show = false;
    }
    if (selectedRole?.role === "Import" && formState.demandType === "Samples") {
      show = false;
    }
    return show;
  };
  // >>>___FileAttachment____
  const [attachmentURL, setAttachmentURL] = useState("");
  const [attachmentURLList, setAttachmentURLList] = useState([]);
  const [openProceedBtn, setOpenProceedBtn] = useState(false);
  const [docError, setDocError] = useState("");
  const [Post, setPost] = useState(true);
  const [ErrorMessageForAmount, setErrorMessageForAmount] = useState("");
  const showAttachmentsHandler = (attachment_URL) => {
    setAttachmentURL(attachment_URL);
  };

  // to upload the file and get path.
  const poBasedHandler = (e) => {
    setPoBasedState(e.target.value);
    clearState(setFormState);
  };
  const confirmedForInvoiceCreation = () => {
    setErrorMessage("");
    if (taxFormState?.isReturn) {
      changeInvoiceStatus(
        formState.invoice_Id,
        statusForPayload,
        setConfirmationModal,
        setAttachInvoiceLoading,
        setSuccessMessage,
        setErrorMessage,
        navigate,
        taxFormState.comments,
        "",
        setPost
      );
      setConfirmationModal(false);
    } else {
      updateInvoiceByTaxTeam(
        taxFormState,
        setTaxFormState,
        setErrorMessage,
        setSuccessMessage,
        setAttachInvoiceLoading,
        setOpenProceedBtn,
        navigate,
        setPost
      );
    }
  };
  const submitHandler = (e) => {
    const totalZ1Z3 =
      calculateTotalGLAmount("Z1") + calculateTotalGLAmount("Z3");
    const totalZ2Z4 =
      calculateTotalGLAmount("Z2") + calculateTotalGLAmount("Z4");
    e.preventDefault();
    if (taxFormState?.isReturn) {
      setConfirmationModal(true);
    } else {
      const invoiceAmount = parseFloat(formState?.invoice_Amount) || 0;
      const IncomebaseAmount = parseFloat(totalZ1Z3) || 0;
      const SalebaseAmount = parseFloat(totalZ2Z4) || 0;
      if (taxErrorMsg) {
        if (errorMessageRef.current) {
          errorMessageRef.current.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }
      } else if (invoiceAmount !== IncomebaseAmount && IncomebaseAmount !== 0) {
        setErrorMessageForAmount(
          "Income Tax WH base amount must be equal to Invoice Amount."
        );
        // Scroll to the error message section
        if (errorMessageRef.current) {
          errorMessageRef.current.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }
      } else if (SalebaseAmount > invoiceAmount && SalebaseAmount !== 0) {
        setErrorMessageForAmount(
          "The Sale Tax WH base amount should not exceed the Invoice Amount."
        );
        // Scroll to the error message section
        if (errorMessageRef.current) {
          errorMessageRef.current.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }
      } else if (taxFormState?.taxCard_List?.length === 0) {
        if (errorMessageRef.current) {
          errorMessageRef.current.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }
      } else {
        setErrorMessageForAmount("");
        setOpenProceedBtn(true);
      }
    }
  };
  const handleChangePage = (event, newPage) => {
    setFormState((formState) => ({
      ...formState,
      PageNo: newPage,
    }));
  };

  const handleChangeRowsPerPage = (event) => {
    // setRowsPerPage(parseInt(event.target.value, 10));

    setFormState((formState) => ({
      ...formState,
      RowsOfPage: event.target.value,
    }));
    // setPage(0);
  };
  const [count, setCount] = useState(0);
  const [invoiceLoading, setInvoiceLoading] = useState(false);
  const [PO_InvoiceAmountforTax, setPO_InvoiceAmountforTax] = useState("");
  useEffect(() => {
    getRefrenceDataList(
      "invoiceType",
      "invoice_Type",
      () => {},
      setMultipleData
    );
    if (invoicePayload && role) {
      getInvoiceByInvoiceIdAndRoleId(
        invoicePayload,
        role,
        setFormState,
        setPoBasedState
      );
      getAllInvoiceDetailByInvoiceId(
        setFormState,
        () => {},
        invoicePayload?.Invoice_id,
        () => {},
        () => {},
        "",
        setInvoiceLoading,
        () => {}
      );
      // getInvoiceByInvoiceIdAndRoleId(
      //   setIsLoading,
      //   invoicePayload,
      //   role,
      //   setFormState
      // );
      getCommentsByInvoiceId(
        setCommentsList,
        setCommentsLoading,
        invoicePayload?.Invoice_id
      );
      vendorTaxDetailForCnic(
        setTaxFormState,
        invoicePayload?.Vendor_Code,
        setCount
      );
    }
  }, []);

  useEffect(()=>{
    setTaxFormState((taxformState)=>({
      ...taxformState , 
      taxCard_List : formState?.taxCard_List
    }))

  },[formState?.taxCard_List])
  useEffect(() => {
    if (formState?.pO_Based) {
      if (
        formState?.invoicePORef_List &&
        formState?.invoicePORef_List?.length > 0
      ) {
        // Run your logic if invoicePORef_List has a value and its length is greater than 0
        const totalAmount = formState?.invoicePORef_List?.reduce(
          (acc, item) => acc + parseFloat(item.inpuT_VAL || 0),
          0
        );

        let totalAmountString = totalAmount?.toString();

        setPO_InvoiceAmountforTax(totalAmountString);
      }
    }
  }, [formState.invoicePORef_List]);
  // import this
  useEffect(() => {
    //
    // formState?.additionalDocIds);
    let filterd_data = [];
    if (formState?.additionalDocIds?.length > 0) {
      filterd_data = formState.additionalDocIds.filter((e) => Number(e) !== 0);
      // setAttachmentURLList((pre) => ([...pre, formState?.invoice_attachment,
      // ...filterd_data]))
    }

    setAttachmentURLList((pre) => [
      formState?.invoice_attachment,
      ...filterd_data,
    ]);
    setAttachmentURL(formState?.invoice_attachment);
  }, [formState?.invoice_attachment, formState?.additionalDocIds]);

  useEffect(() => {
    if (taxFormState?.additionalDocIds?.length > 0) {
      setAttachmentURLList((pre) => [
        ...pre,
        taxFormState?.additionalDocIds[
          taxFormState?.additionalDocIds?.length - 1
        ],
      ]);
    }
    // if (taxFormState?.additionalDocIds?.length > 1) {
    //   setAttachmentURLList((pre) => ([...pre, taxFormState?.additionalDocIds[(taxFormState?.additionalDocIds.length - 1)]]))
    // } else {
    //   setAttachmentURLList((pre) => ([...pre, ...taxFormState?.additionalDocIds]))
    // }
  }, [taxFormState?.additionalDocIds]);

  const [vendor__Code, setVendor__Code] = useState("");
  useEffect(() => {
    if (taxFormState?.vendor_Code) {
      setVendor__Code(taxFormState?.vendor_Code);
    } else {
      setTaxFormState((formState) => ({
        ...formState,
        vendor_Code: vendor__Code,
      }));
    }
  }, [taxFormState.vendor_Code]);
  const [dragfile, setDragFile] = useState(false);
  const [dragloader, setDragLoader] = useState(false);
  const handleDrag = function (e) {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === "dragenter" || e.type === "dragover") {
      setDragLoader(true);
    } else if (e.type === "dragleave") {
      setDragLoader(false);
      setDragFile(true);
    }
  };
  const handleDrop = function (e) {
    e.preventDefault();
    e.stopPropagation();
    setDragLoader(false);

    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      uploadAdditioalDocumentFile(
        e,
        setTaxFormState,
        setAttachInvoiceLoading,
        "additionalDocIds",
        additionalAttachmentRef,
        setDocError,
        setAttachError,
        setAlertMessage,
        invoicePayload,
        selectedRole,
        dragfile,
        setDragFile,
        setSuccessMessage
      );
    }
  };
  const isContainEmailFormate = (fileExtension) => {
    const emailExtensions = [
      "eml",
      "msg",
      "pst",
      "mbox",
      "emlx",
      "dbx",
      "mbx",
      "nws",
      "p7m",
      "mht",
      "mhtml",
      "rar",
      "zip",
    ];
    return emailExtensions.includes(fileExtension.toLowerCase());
  };
  const calculateTotalGLAmount = (taxType) => {
    const filteredList = taxFormState?.taxCard_List?.filter(
      (data) => data?.taxType?.split("-")[0]?.trim() === taxType
    );
    const totalAmount = filteredList?.reduce(
      (prev, curr) => prev + Number(curr.amount),
      0
    );
    return totalAmount;
  };

  // const totalZ1Z3 = calculateTotalGLAmount("Z1") + calculateTotalGLAmount("Z3");
  // const totalZ2Z4 = calculateTotalGLAmount("Z2") + calculateTotalGLAmount("Z4");

  return (
    <>
      {/* {allowToProceed ? ( */}
        <Card
          onDragEnter={handleDrag}
          onDragLeave={handleDrag}
          onDragOver={handleDrag}
          onDrop={handleDrop}
        >
          <Backdrop
            sx={{
              color: "#fff",
              zIndex: (theme) => theme.zIndex.drawer + 1,
            }}
            open={dragloader || invoiceLoading}
          ></Backdrop>
          <CardHeader color="primary" text>
            <CardText
              style={{
                padding: "0px 20px",
                backgroundColor: "#031C30",
                color: "white",
              }}
            >
              <Grid container justifyContent="space-between">
                <Grid item xs={2} sm={3} md={3} lg={6}>
                  <h1 style={{ fontSize: "24px" }}>Tax Check</h1>
                </Grid>
                <Grid item xs={6} sm={6} md={6} lg={6}>
                  <IconButton
                    variant="contained"
                    style={{ float: "right", marginTop: "1.5%" }}
                    onClick={() => navigate("/home")}
                  >
                    <ArrowBack
                      style={{ color: "#fff" }}
                      titleAccess="Go Back"
                    />
                  </IconButton>
                </Grid>
              </Grid>
            </CardText>
          </CardHeader>
          <CardBody>
            <Backdrop
              sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
              open={attachInvoiceLoading}
            >
              <CircularProgress color="inherit" />
            </Backdrop>

            <form onSubmit={submitHandler} ref={errorMessageRef}>
              {formState.invoice_No && (
                <TaxDetail
                  formState={taxFormState}
                  setFormState={setTaxFormState}
                  invoice_Amount={
                    formState.pO_Based
                      ? PO_InvoiceAmountforTax
                        ? PO_InvoiceAmountforTax
                        : formState.invoice_Amount
                      : formState.invoice_Amount
                  }
                  saletaxcode={() => {}}
                />
              )}
              {ErrorMessageForAmount && (
                <Grid container spacing={0}>
                  <Grid item>
                    <Error
                      titleAccess="Error"
                      className={classes.asterisk}
                      fontSize="small"
                    />{" "}
                  </Grid>
                  <Grid item>
                    <Typography className={classes.asterisk} ml={1}>
                      {" "}
                      {ErrorMessageForAmount}
                    </Typography>
                  </Grid>
                </Grid>
              )}
              {formState.invoice_No && (
                <TaxTableV2
                  formState={taxFormState}
                  setFormState={setTaxFormState}
                  invoice_Amount={formState.invoice_Amount}
                  isPo={formState.pO_No}
                  invoicePayload={invoicePayload}
                  edit={edit === "true" ? true : false}
                  isProceed={taxFormState.isProceed}
                  setTaxErrorMsg={setTaxErrorMsg}
                  taxErrorMsg={taxErrorMsg}
                />
              )}
              {/* {
            <TaxTeamTable
            formState={taxFormState}
            setFormState={setTaxFormState}
            invoice_Amount={formState.invoice_Amount}
            invoicePayload={invoicePayload}
            edit={edit}
            isProceed={taxFormState.isProceed}
            />
            } */}
              {formState.invoice_No && (
                <VendorTaxTable
                  formState={taxFormState}
                  setFormState={setTaxFormState}
                />
              )}
              {/* <TablePagination
          rowsPerPageOptions={[25, 50, 100]}
          component="div"
          count={count}
          rowsPerPage={formState.RowsOfPage}
          page={parseInt(formState.PageNo) - 1}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
        */}
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <CommentHistory
                  commentsList={commentsList}
                  commentsLoading={commentsLoading}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={3} mt={0}>
                <Typography style={{ color: "black" }}>
                  Additional Document:
                  {/* <span className={classes.asterisk}>*</span> */}
                </Typography>
                <TextField
                  fullWidth
                  size="small"
                  sx={{
                    "& .MuiInputBase-root": {
                      height: 30,
                    },
                    "& legend": { display: "none" },
                    "& fieldset": { top: 0 },
                  }}
                  id="outlined-basic"
                  variant="outlined"
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <input
                          ref={additionalAttachmentRef}
                          type="file"
                          name="additionalDocIds"
                          // accept="application/pdf, image/png , image/jpg , image/jpeg "
                          // required={taxFormState.additionalDocIds.length === 0}
                          onChange={(e) =>
                            uploadAdditioalDocumentFile(
                              e,
                              setTaxFormState,
                              setAttachInvoiceLoading,
                              "additionalDocIds",
                              additionalAttachmentRef,
                              setDocError,
                              setAttachError,
                              setAlertMessage,
                              invoicePayload,
                              selectedRole,
                              dragfile,
                              setDragFile,
                              setSuccessMessage
                            )
                          }
                          style={{ width: "209px" }}
                          multiple
                        />
                      </InputAdornment>
                    ),
                  }}
                  // FormHelperTextProps={{
                  //   className: classes.helperText,
                  // }}
                  // error={docError ? true : false}
                  // helperText= {docError ? `${docError}` : null}
                />

                {taxFormState.additionalDocIds?.length > 0 &&
                  taxFormState.additionalDocIds.map((f, index) => {
                    const s = f?.path?.split("\\");
                    const ss = s[s?.length - 1];
                    return (
                      <div>
                        {f?.path !== "" ? (
                          <>
                            <IconButton>
                              <Delete
                                color="danger"
                                fontSize="small"
                                onClick={() => {
                                  setOpenWarningBox(true);

                                  setCurrentStateForDeleteion({
                                    ss,
                                    f,
                                  });
                                }}
                              />
                            </IconButton>
                            <IconButton>
                              <Download
                                titleAccess="Download"
                                color="secondary"
                                fontSize="small"
                                onClick={() => {
                                  downloadAttachments(f?.path);
                                }}
                              />{" "}
                            </IconButton>
                            <IconButton
                              size="small"
                              onClick={() => {
                                const extension = f.path
                                  ?.match(/\.[^.]+$/)[0]
                                  .substring(1);

                                const allowedExtensions = [
                                  ".png",
                                  ".pdf",
                                  ".jpg",
                                  ".jpeg",
                                  ".PNG",
                                  ".JPG",
                                  ".JPEG",
                                  ".PNG",
                                  ".PDF",
                                ];
                                const fileExtension = "." + ss.split(".").pop();
                                if (allowedExtensions.includes(fileExtension)) {
                                  setAttachmentURL(f);
                                } else {
                                  if (isContainEmailFormate(extension)) {
                                    downloadAttachments(f.path);
                                  } else {
                                    setAttachmentURL(f);

                                    window.open(
                                      `${process.env.REACT_APP_API_URL}/${f.path}`,
                                      "_blank"
                                    );
                                  }
                                }
                              }}
                            >
                              <span style={{ fontSize: "12px" }}>{ss}</span>
                              {/* <a
                            style={{
                              fontSize: "14px",
                              textDecoration: "none",
                              color: "black",
                            }}
                            href={`${process.env.REACT_APP_API_URL}/Uploads/${ss}`}
                            target="_blank"
                          >
                            {ss}
                          </a>*/}
                            </IconButton>
                          </>
                        ) : (
                          ""
                        )}
                      </div>
                    );
                  })}
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={12}>
                <Typography style={{ marginTop: "4px", color: "black" }}>
                  Comments:
                  {/* <span className={classes.asterisk}>*</span> */}
                </Typography>
                <TextField
                  fullWidth
                  multiline
                  rows={2}
                  maxRows={4}
                  // size="small"
                  sx={{
                    // width: "70%",
                    "& legend": { display: "none" },
                    "& fieldset": { top: 0 },
                  }}
                  id="outlined-basic"
                  variant="outlined"
                  name="comments"
                  required={taxFormState?.isReturn}
                  value={taxFormState.comments}
                  onChange={taxChangeHandler}
                />
              </Grid>
              {(Post && allowToProceed) && (
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={3}
                  lg={12}
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    marginTop: "10px",
                  }}
                >
                  <Button
                    style={{
                      margin: "2px",
                      color: "white",
                      backgroundColor: "#ED1C24",
                    }}
                    variant="contained"
                    // color="danger"
                    onClick={() => navigate("/home")}
                  >
                    CANCEL
                  </Button>
                  <Button
                    style={{
                      margin: "2px",
                      backgroundColor: "black",
                      color: "white",
                    }}
                    variant="contained"
                    // color="inherit"
                    type="submit"
                    onClick={() => {
                      setTaxFormState((taxFormState) => ({
                        ...taxFormState,
                        isReturn: true,
                        isProceed: false,
                      }));
                      setConfirmationMessage(
                        "Are you sure to send invoice to Invoice Receiver"
                      );
                      setStatusForPayload("SendToIRFromTaxTeam");
                    }}
                  >
                    Send Back
                  </Button>
                  <Button
                    style={{ margin: "2px" }}
                    variant="contained"
                    color="secondary"
                    type="submit"
                    onClick={() => {
                      setTaxFormState((taxFormState) => ({
                        ...taxFormState,
                        isReturn: false,
                        isProceed: true,
                      }));
                    }}
                  >
                    PROCEED
                  </Button>
                </Grid>
              )}
              {errorMessage && (
                <>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                    }}
                  >
                    <Grid item>
                      <Error
                        titleAccess="Error"
                        className={classes.asterisk}
                        fontSize="small"
                      />{" "}
                    </Grid>
                    <Grid item>
                      <Typography className={classes.asterisk} ml={1}>
                        {" "}
                        {errorMessage}
                      </Typography>
                    </Grid>
                  </Box>
                </>
              )}

              <Heading title="Invoice Detail" />
              <Grid container style={{ padding: "0px 5px 0px 6px" }}>
                <Grid item xs={12} sm={12} md={12} lg={6}>
                  {/* Check boxes */}
                  <InvoiceCheckboxes
                    formState={formState}
                    setFormState={setFormState}
                    selectedRole="TaxTeam"
                    disabled={true}
                  />

                  {/* Radio Buttons */}
                  <InvoiceRadioButtons
                    formState={formState}
                    setFormState={setFormState}
                    selectedRole="TaxTeam"
                    // physicalOrEInvoice={physicalOrEInvoice}
                    poBasedState={poBasedState}
                  />

                  {/* text Fields */}
                  <InvoiceTextField
                  formState={{
                    ...formState , 
                    po_Date : formState?.po_Date , 
                    plant_Code : formState?.plant_Code
                  }}
                    newFormState={formState}
                    setNewFormState={setFormState}
                    selectedRole="TaxTeam"
                    disabled={true}
                    poBasedState={poBasedState}
                    showVendorAndPO_NumberForImport={
                      showVendorAndPO_NumberForImport
                    }
                    showVendorCodeForImport={showVendorCodeForImport}
                    invoice_attachmentRef={invoice_attachmentRef}
                    additionalAttachmentRef={additionalAttachmentRef}
                    setAttachInvoiceLoading={setAttachInvoiceLoading}
                    // setAttchmentFile_UI={setAttchmentFile_UI}
                    // attachmentFile_UI={attachmentFile_UI}
                    // physicalOrEInvoice={physicalOrEInvoice}
                    changeHandler={changeHandler}
                    alignForAttachment={true}
                    showAttachmentsHandler={showAttachmentsHandler}
                    attachmentURLList={attachmentURLList}
                    setAttachmentURLList={setAttachmentURLList}
                    multipleData={multipleData}
                    setAttachmentURL={setAttachmentURL}
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  lg={6}
                  style={{ paddingLeft: "10px" }}
                >
                  <Heading title="Attachment Preview" />
                  <AttachmentsCover
                    attachmentURLList={attachmentURLList}
                    setAttachmentURLList={setAttachmentURLList}
                    attachmentURL={attachmentURL}
                    setAttachmentURL={setAttachmentURL}
                  />
                  {/* <FileAttachments
                // imgsrc={attachmentURL}
                //  imgPreview={imgPreview}
                pdfHeight={"34%"}
                docsrc={attachmentURL}
                // docPreview={docPreview}
              /> */}
                  {/* <DocViewer
         documents={docs}
      initialActiveDocument={docs[1]}
      pluginRenderers={DocViewerRenderers}
      config={{
        noRenderer: {
          overrideComponent: ({ document, fileName }) => {
            const fileText = fileName || document?.fileType || "";
            
            if (fileText) {
              return <div>no renderer for {fileText}</div>;
            }
            return <div>no renderer</div>;
          },
        },
        loadingRenderer: {
          overrideComponent: ({ document, fileName }) => {
            const fileText = fileName || document?.fileType || "";
            if (fileText) {
              return <div>loading ({fileText})</div>;
            }
            return <div>loading</div>;
          },
        },
        csvDelimiter: ",",
        pdfZoom: {
          defaultZoom: 1.1,
          zoomJump: 0.2,
        },
      }}
      language="pl"
    /> */}
                </Grid>
              </Grid>
              {formState?.pO_Based && (
                <PODetail
                  setSelectedTotal={() => {}}
                  Invoice_id={invoicePayload?.Invoice_id}
                  formState={formState}
                  setFormState={setFormState}
                  disabled={true}
                  checkedBox={true}
                  deletee={false}
                  // loading={multiValLoading}
                />
              )}
            </form>
          </CardBody>

          {openInvoiceGuideLine && (
            <InvoiceGuideLine
              open={openInvoiceGuideLine}
              close={setOpenInvoiceGuideLine}
            />
          )}
          {confirmationModal && (
            <ConfirmationModal
              open={confirmationModal}
              close={() => setConfirmationModal(false)}
              message={confirmationMessage}
              submit={confirmedForInvoiceCreation}
              loading={attachInvoiceLoading}
            />
          )}
          {openProceedBtn && (
            <ProceedBtn
              open={openProceedBtn}
              close={() => setOpenProceedBtn(false)}
              submit={confirmedForInvoiceCreation}
              attachInvoiceLoading={attachInvoiceLoading}
              formState={taxFormState}
            />
          )}
          {successMessage && (
            <CustomSnackbar
              open={successMessage !== ""}
              message={successMessage}
              handleClose={() => setSuccessMessage("")}
              variant="success"
            />
          )}

          {openWarningBox && (
            <WarningBox
              open={openWarningBox}
              close={() => setOpenWarningBox(false)}
              submit={deleteAttachmentFunc}
              message="Are you sure to delete attachment"
              deleteLoader={deleteLoader}
              allow={1}
            />
          )}
          {alertMessage && (
            <POAlertDialog
              setAlertMessage={setAlertMessage}
              message={attachError ? attachError : docError}
              setAttachError={setAttachError}
              setDocError={setDocError}
            />
          )}
        </Card>
      {/* ) : (
        <PageNotFound />
      )} */}
    </>
  );
};

export default TaxTeamPage;
